//http工具包
import qs from 'qs';
import axios from 'axios';

const TIME_OUT_MS = 30 * 1000;

let context;

function getRemoteMessage(remoteResponse) {
	if(!remoteResponse) {
		return '';
	}
	if(remoteResponse.message) {
		if(typeof remoteResponse.message === 'string') {
			return remoteResponse.message;
		}
		if(remoteResponse.message.errorMessage) {
			return remoteResponse.message.errorMessage;
		}
		if(remoteResponse.message.successMessage) {
			return remoteResponse.message.successMessage;
		}
	}
	return remoteResponse.returnMessage ||
		remoteResponse.errorMessage ||
		remoteResponse.errorMsg ||
		remoteResponse.rtnMsg ||
		remoteResponse.msg ||
		'';
}

function getExceptionMessage(error) {
	if(error && error.response && error.response.data) {
		return getRemoteMessage(error.response.data);
	}
	return getRemoteMessage(error && error.data) || (error && error.message) || '';
}

function getLoginRedirectBase() {
	var indexUrl = process.env.NODE_ENV === 'development' ?
		window.location.origin + '/' :
		window.location.origin + '/dist/index.html';
	return indexUrl + '#/login?u=';
}

/**
 *
 * @param response
 * @param params 给所有的结果集合返回列表的index
 * @returns {Object}
 * {
 *     success: true,
 *     message: '',
 *     data: {
 *
 *          ...
 *
 *          total: 0,
 *          results: []
 *     }
 * }
 */
function handleResult(response, url) {
	var result = {
		success: false,
		message: '',
		successMsg: '',
		data: {
			total: 0,
			results: []
		},
		returnMessage: ''
	};

	let remoteResponse = response.data;
	if(remoteResponse && remoteResponse.data && remoteResponse.data.list && Array.isArray(remoteResponse.data.list)) return  remoteResponse
	
	if(remoteResponse && remoteResponse.success) {
		if(!remoteResponse.model) {
			result.message = getRemoteMessage(remoteResponse);
			result.successMsg = remoteResponse.message && remoteResponse.message.successMessage;
			result.data = remoteResponse.data
		} else if(remoteResponse.model) {
			result.message = getRemoteMessage(remoteResponse);
			result.successMsg = remoteResponse.message && remoteResponse.message.successMessage;
			result.data = remoteResponse.model;
		}
		result.success = true;
	} else if(remoteResponse.errorCode && remoteResponse.errorCode == '-1') {
		//		setTimeout(function() {
		if(url.indexOf('getMsgCount') == -1) {
			context.$Message.error({
				content: "登录证书已过期或者未登录系统，请到登录页面登录系统",
				duration: 2
			})
			var currentUrl = getLoginRedirectBase();
			var url = window.location.href;
			window.location.href = currentUrl + url;
		}
		//		}, 1000)

	} else {
		var msg = getRemoteMessage(remoteResponse);
		if(!msg) {
			msg = '未查询到结果';
		}

		result.message = msg;
		result.returnMessage = msg;
		result.success = false;
	}
	return result;
}

function getResult(response) {
	var result = {
		message: '',
		data: ''
	};

	let remoteResponse = response.data;
	if(remoteResponse.returnCode) return remoteResponse
	if(remoteResponse && remoteResponse.rtnCode == 0) {
		if(remoteResponse.rtnData) {
			result.data = remoteResponse.rtnData

		} else {
			result.message = remoteResponse.rtnMsg;
		}
	} else if(remoteResponse.errorCode && remoteResponse.errorCode == '-1') {
		context.$Message.error({
			content: "登录证书已过期或者未登录系统，请到登录页面登录系统",
			duration: 2
		})
		//		setTimeout(function() {
		var currentUrl = getLoginRedirectBase();
		var url = window.location.href;
		window.location.href = currentUrl + url;
		//		}, 1000)
		return false;
	} else {
		let msg = remoteResponse.rtnMsg;
		if(!msg) {
			msg = '未查询到结果';
		}
		result.message = msg;
		context.$Message.info(msg);
	}
	return result;
}

/**
 *
 * @param error
 */
function handleException(error) {
	var msg = getExceptionMessage(error) || '服务器异常';
	context.$Message.error(msg);
}

function joinAddress(url) {
	//	var u = location.href;
	//	var u = queryString('u')
	//	alert(u)
	var actUrl = url;
	if(sessionStorage.getItem('certificate')) {
		if(url.indexOf('?') == -1) {
			actUrl += "?token=" + sessionStorage.getItem('certificate')
		} else {
			actUrl += "&token=" + sessionStorage.getItem('certificate')
		}

		// data.token = '4028860f5f532f72015f6cf960f7001f';
	}

	//	if(url && !url.startsWith('/')) {
	//		actUrl = '/' + url;
	//	} else {
	//		actUrl = url;
	//	}
	// 本地测试使用代码
	/* let flag = false
	let array = [
		'tool/risk/push',
		'tool/updateBatchCheckDetail',
		'tool/batchCheckDetail',
		'invoice/check/util/updateInvoice',
		'invoice/check/util/mockRisk',
		'loginV3'
	]
	array.forEach(item => {
		if(url.indexOf(item) != -1)  {
			// 说明匹配上了
			flag = true
		}
	});
	if(flag) return url  */
	// return url
	return url.indexOf('http') != -1 ? actUrl : BASE_URL + actUrl
}

function joinParams(data) {
	if(!data) {
		return;
	}
	//	if(!data.uid) {
	//		data.uid = sessionStorage.getItem('uid');
	//		// data.uid = 'kpy336';
	//	}
	//	if(!data.token && sessionStorage.getItem('certificate')) {
	//		data.token = sessionStorage.getItem('certificate');
	//		// data.token = '4028860f5f532f72015f6cf960f7001f';
	//	}
	return data
}

function checkHasKey() {
	if(!sessionStorage.getItem('token')) {
		return false
	} else {
		return true;
	}
}

export default {
	initContext(vue) {
		context = vue;
	},
	post(url, data, response, exception) {
		//		calibration.calibration(data)
		this.actPost(url, data, response, exception);
	},
	initPost(url, data, response, exception) {
		//		calibration.calibration(data)
		this.simplePost(url, data, response, exception);
	},

	/**
	 *
	 * @param url
	 * @param data
	 * @param response 请求成功时的回调函数
	 * @param exception 异常的回调函数
	 */
	simplePost(url, data, response, exception) {
		axios({
			method: 'post',
			url: joinAddress(url),
			data: data,
			timeout: TIME_OUT_MS,
			headers: {
				'Content-Type': 'application/json; charset=UTF-8'
			}
		}).then(
			(result) => {
				if(response) {
					response(handleResult(result, data, url));
				} else {
					context.$Message.error('操作错误！');
				}
			}
		).catch(
			(error) => {
				if(exception) {
					exception(error)
				} else {
					handleException(error);
				}
			}
		)

	},

	/**
	 *
	 * @param url
	 * @param data
	 * @param response 请求成功时的回调函数
	 * @param exception 异常的回调函数
	 */
	actPost(url, data, response, exception) {
		//		if (checkHasKey() ) {
		axios({
			method: 'post',
			url: joinAddress(url),
			data: joinParams(data),
			timeout: TIME_OUT_MS,
			headers: {
				'Content-Type': 'application/json; charset=UTF-8'
			}
		}).then(
			(result) => {
				if(response) {
					response(handleResult(result, url));
				} else {
					context.$Message.error('操作错误！');
				}
			}
		).catch(
			(error) => {
				if(exception) {
					exception(error)
				} else {
					console.log(error)
					handleException(error);
				}
			}
		)
	},
	get(url, response, exception) {
		//		if (checkHasKey()) {
		axios({
				method: 'get',
				url: joinAddress(url),
				timeout: TIME_OUT_MS,
				headers: {
					'Content-Type': 'application/json; charset=UTF-8'
				}
			}).then(
				(result) => {
					if(response) {
						response(getResult(result));
					} else {
						context.$Message.error('操作错误！');
					}
				}
			)
			.catch(
				(error) => {
					console.log(error)
					if(exception) {
						exception(error)
					} else {
						handleException(error);
					}
				}
			)
	}
}



// WEBPACK FOOTER //
// ./src/utils/http.js